<template>
  <el-tabs v-model="activeName" type="border-card" style="width: 100%;">
    <el-tab-pane label="国际化批量管理" name="first">
      <div class="main">
        <div class="main_r">
          <!-- 筛选区域 -->
          <div class="search">
            <div>
              <el-select v-model="queryData.entityType" placeholder="选择模块" @change="handleEntityTypeChange">
                <el-option v-for="(label, key) in entityTypeLabels" :key="key" :label="label" :value="key"></el-option>
              </el-select>
              <el-select v-model="queryData.status" placeholder="翻译状态">
                <el-option label="全部" value="all"></el-option>
                <el-option label="未翻译" value="none"></el-option>
                <el-option label="部分翻译" value="partial"></el-option>
                <el-option label="已完成" value="complete"></el-option>
              </el-select>
              <el-input v-model="queryData.keyword" placeholder="请输入搜索关键词" style="width: 200px;"></el-input>
              <el-button type="primary" @click="clickQuery">查询</el-button>
              <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
            </div>
          </div>
          <!-- 筛选区域 End -->

          <!-- 数据表格 -->
          <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" border>
            <el-table-column prop="id" label="序号" width="80"></el-table-column>
            <el-table-column label="模块" width="100">
              <template slot-scope="scope">
                <span>{{ entityTypeLabels[scope.row.entityType] || scope.row.entityType }}</span>
              </template>
            </el-table-column>
            <el-table-column label="源文本" min-width="200">
              <template slot-scope="scope">
                <div class="source-fields">
                  <div v-for="field in getCurrentFields(scope.row)" :key="field.name" class="field-item">
                    <span class="field-label">{{ field.label }}:</span>
                    <span class="field-value">{{ (scope.row.sourceFields && scope.row.sourceFields[field.name]) || '-' }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="English" min-width="220">
              <template slot-scope="scope">
                <div class="translation-fields">
                  <div v-for="field in getCurrentFields(scope.row)" :key="field.name" class="field-item">
                    <span class="field-label">{{ field.label }}:</span>
                    <el-input
                      size="small"
                      v-model="scope.row.translations.en[field.name]"
                      :placeholder="field.label"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 3 }"
                    ></el-input>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Deutsch" min-width="220">
              <template slot-scope="scope">
                <div class="translation-fields">
                  <div v-for="field in getCurrentFields(scope.row)" :key="field.name" class="field-item">
                    <span class="field-label">{{ field.label }}:</span>
                    <el-input
                      size="small"
                      v-model="scope.row.translations.de[field.name]"
                      :placeholder="field.label"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 3 }"
                    ></el-input>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="繁體中文" min-width="220">
              <template slot-scope="scope">
                <div class="translation-fields">
                  <div v-for="field in getCurrentFields(scope.row)" :key="field.name" class="field-item">
                    <span class="field-label">{{ field.label }}:</span>
                    <el-input
                      size="small"
                      v-model="scope.row.translations['zh-Hant'][field.name]"
                      :placeholder="field.label"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 3 }"
                    ></el-input>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 'complete'" type="success" size="small">已完成</el-tag>
                <el-tag v-else-if="scope.row.status === 'partial'" type="warning" size="small">部分翻译</el-tag>
                <el-tag v-else type="info" size="small">未翻译</el-tag>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="page_size"
              layout="prev, pager, next, sizes, jumper"
              :total="dataListTotal">
            </el-pagination>
          </div>
          <!-- 分页 End -->

          <!-- 底部操作 -->
          <div class="mt20" style="text-align: right;">
            <el-button type="primary" @click="saveChanges" :loading="saving">保存当前页修改</el-button>
          </div>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default {
  name: 'I18nBatchManagement',
  data() {
    return {
      activeName: 'first',
      queryData: {
        entityType: 'ACTION',
        status: 'all',
        keyword: ''
      },
      dataList: [],
      originalData: [],
      dataListTotal: 0,
      page_no: 1,
      page_size: 10,
      saving: false,
      entityTypeLabels: {
        'ACTION': '动作库',
        'COURSE': '课程库',
        'TRAIN_PLAN': '训练计划',
        'GV': '字典',
        'NOTICE': '通知',
        'HELP_CENTER': '帮助中心',
        'REWARD': '奖品管理'
      },
      fieldConfig: {
        'ACTION': [
          { name: 'action_name', label: '动作名称' },
          { name: 'action_execution_point', label: '动作要领' },
          { name: 'action_respiratory_rate', label: '呼吸方法' },
          { name: 'action_sense', label: '动作感觉' },
          { name: 'action_error_correction', label: '易犯错误' }
        ],
        'COURSE': [
          { name: 'course_name', label: '课程名称' },
          { name: 'banner_title', label: '推荐标题' },
          { name: 'banner_description', label: '推荐描述' }
        ],
        'TRAIN_PLAN': [
          { name: 'train_plan_name', label: '计划名称' },
          { name: 'banner_title', label: '推荐标题' },
          { name: 'banner_description', label: '推荐描述' }
        ],
        'GV': [
          { name: 'name', label: '名称' }
        ],
        'NOTICE': [
          { name: 'notice_title', label: '消息标题' },
          { name: 'notice_content', label: '消息内容' }
        ],
        'HELP_CENTER': [
          { name: 'question', label: '问题' },
          { name: 'answer', label: '回答' }
        ],
        'REWARD': [
          { name: 'reward_name', label: '奖品名称' },
          { name: 'description', label: '奖品描述' }
        ]
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    getCurrentFields(row) {
      const baseFields = this.fieldConfig[this.queryData.entityType] || []
      // 对 GV 类型，如果是协议/政策/须知类记录，额外显示 gv 字段
      if (this.queryData.entityType === 'GV' && row && row.sourceFields && row.sourceFields.name) {
        const name = row.sourceFields.name
        if (name.indexOf('协议') !== -1 || name.indexOf('政策') !== -1 || name.indexOf('须知') !== -1) {
          return [...baseFields, { name: 'gv', label: '内容' }]
        }
      }
      return baseFields
    },
    handleEntityTypeChange() {
      this.page_no = 1
      this.loadData()
    },
    clickQuery() {
      this.page_no = 1
      this.loadData()
    },
    clickQueryReset() {
      this.queryData = {
        entityType: 'ACTION',
        status: 'all',
        keyword: ''
      }
      this.page_no = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.page_size = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.loadData()
    },
    initTranslations(item) {
      if (!item.translations) {
        item.translations = {}
      }
      if (!item.translations.en) {
        item.translations.en = {}
      }
      if (!item.translations.de) {
        item.translations.de = {}
      }
      if (!item.translations['zh-Hant']) {
        item.translations['zh-Hant'] = {}
      }
      // 确保每个字段都有对应的 key
      const fields = this.getCurrentFields(item)
      fields.forEach(field => {
        if (item.translations.en[field.name] === undefined || item.translations.en[field.name] === null) {
          this.$set(item.translations.en, field.name, '')
        }
        if (item.translations.de[field.name] === undefined || item.translations.de[field.name] === null) {
          this.$set(item.translations.de, field.name, '')
        }
        if (item.translations['zh-Hant'][field.name] === undefined || item.translations['zh-Hant'][field.name] === null) {
          this.$set(item.translations['zh-Hant'], field.name, '')
        }
      })
    },
    loadData() {
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = this.queryData.entityType
      data.keyword = this.queryData.keyword
      data.status = this.queryData.status
      data.pageNo = this.page_no
      data.pageSize = this.page_size
      data.sign = Vue.prototype.FunGetSign(data)

      axios.get(Vue.prototype.global.Url_I18nSourceList, { params: data })
        .then(response => {
          if (response.data.code === 1) {
            var list = response.data.data.list || []
            list.forEach(item => {
              this.initTranslations(item)
            })
            this.dataList = list
            this.dataListTotal = response.data.data.total || 0
            // 深拷贝原始数据用于比较
            this.originalData = JSON.parse(JSON.stringify(this.dataList))
          } else {
            this.$message.error(response.data.msg || '加载失败')
          }
        })
        .catch(error => {
          Vue.prototype.FunRemindNetWorkError(error)
        })
    },
    checkTranslationChanged(item, original) {
      const languages = ['en', 'de', 'zh-Hant']
      const fields = this.getCurrentFields(item)
      for (let lang of languages) {
        for (let field of fields) {
          const currentVal = (item.translations[lang] && item.translations[lang][field.name]) || ''
          const originalVal = (original.translations[lang] && original.translations[lang][field.name]) || ''
          if (currentVal !== originalVal) {
            return true
          }
        }
      }
      return false
    },
    saveChanges() {
      const changedItems = []
      this.dataList.forEach((item, index) => {
        const original = this.originalData[index]
        if (this.checkTranslationChanged(item, original)) {
          changedItems.push({
            entityId: item.id,
            translations: item.translations
          })
        }
      })

      if (changedItems.length === 0) {
        this.$message.info('没有检测到修改')
        return
      }

      this.saving = true
      const requestBody = {
        entityType: this.queryData.entityType,
        items: changedItems
      }

      axios.post(Vue.prototype.global.Url_I18nBatchSave, requestBody, {
        headers: { 'Content-Type': 'application/json' }
      }).then(response => {
        this.saving = false
        if (response.data.code === 1) {
          this.$message.success('保存成功，共更新 ' + changedItems.length + ' 条数据')
          this.loadData()
        } else {
          this.$message.error('保存失败：' + (response.data.msg || '未知错误'))
        }
      }).catch(error => {
        this.saving = false
        Vue.prototype.FunRemindNetWorkError(error)
      })
    }
  }
}
</script>

<style scoped>
.main {
  display: flex;
}
.main_r {
  flex: 1;
}
.search {
  display: flex;
  align-items: center;
}
.search > div {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
}
.mt15 {
  margin-top: 15px;
}
.mt20 {
  margin-top: 20px;
}
.source-fields,
.translation-fields {
  text-align: left;
}
.field-item {
  margin-bottom: 8px;
}
.field-item:last-child {
  margin-bottom: 0;
}
.field-label {
  font-size: 12px;
  color: #909399;
  display: block;
  margin-bottom: 2px;
}
.field-value {
  font-size: 13px;
  color: #303133;
  word-break: break-all;
}
.translation-fields .el-textarea {
  width: 100%;
}
</style>
